import { DATE_INPUT_FORMAT } from "./helpers/dateInputFormat";

// Above form modals (up to 2000) and below notification toasts (2077).
export const dropdownZIndex = 2060;

export const lightSurfaces = {
  canvas: (theme) => theme.colors.gray[0],
  surface: "#ffffff",
  border: (theme) => theme.colors.gray[3],
  borderStrong: (theme) => theme.colors.gray[4],
  hover: (theme) => theme.colors.gray[0],
};

export const theme = {
  colors: {
    deepBlue: ["#E9EDFC", "#C1CCF6", "#99ABF0" /* ... */],
  },

  primaryColor: "cyan",
  dateFormat: DATE_INPUT_FORMAT,

  globalStyles: (theme) => ({
  body: {
    ...(theme.colorScheme === "light"
      ? {
          backgroundColor: theme.colors.gray[0],
        }
      : {}),
  },
  }),

  components: {
    DatePicker: {
      defaultProps: {
        inputFormat: DATE_INPUT_FORMAT,
        withinPortal: true,
        zIndex: dropdownZIndex,
      },
    },

    Select: {
      defaultProps: {
        withinPortal: true,
        zIndex: dropdownZIndex,
      },
    },

    MultiSelect: {
      defaultProps: {
        withinPortal: true,
        zIndex: dropdownZIndex,
      },
    },

    Autocomplete: {
      defaultProps: {
        withinPortal: true,
        zIndex: dropdownZIndex,
      },
    },

    Badge: {
      styles: (theme, params) => {
        if (theme.colorScheme === "light") {
          const baseColor =
            theme.colors[params.color]?.[6] || theme.colors.blue[6];

          return {
            root: {
              backgroundColor: baseColor,
              color: "white",
            },
          };
        }

        return {};
      },
    },

    Button: {
      styles: (theme, params) => {
        if (theme.colorScheme !== "light" || params.variant !== "light") {
          return {};
        }

        const color = params.color || theme.primaryColor;
        const palette = theme.colors[color] || theme.colors.cyan;

        return {
          root: {
            backgroundColor: palette[2],
            color: palette[8],
            "&:hover": {
              backgroundColor: palette[3],
            },
          },
        };
      },
    },

    Title: {
      defaultProps: (theme) => ({
        color: theme.colorScheme === "dark" ? "white" : theme.colors.dark[5],
      }),
    },

    Text: {
      defaultProps: (theme) => ({
        color:
          theme.colorScheme === "dark"
            ? theme.colors.gray[4]
            : theme.colors.dark[9],
      }),
      styles: (theme, params) => {
        if (theme.colorScheme === "light" && params.color === "dimmed") {
          return {
            root: {
              color: theme.colors.gray[7],
            },
          };
        }

        return {};
      },
    },

    Tabs: {
      styles: (theme) => ({
        tab: {
          ...(theme.colorScheme === "light"
            ? {
                color: theme.colors.gray[7],
                "&[data-active]": {
                  color: theme.colors.dark[9],
                },
              }
            : {}),
        },
      }),
    },

    Paper: {
      styles: (theme) => ({
        root: {
          ...(theme.colorScheme === "light"
            ? {
                backgroundColor: theme.white,
                border: `1px solid ${theme.colors.gray[3]}`,
              }
            : {}),
        },
      }),
    },

    Input: {
      styles: (theme) => ({
        input: {
          "&:disabled": {
            color:
              theme.colorScheme === "dark"
                ? theme.colors.gray[0]
                : theme.colors.dark[9],
          },
        },
        label: {
          color: "red",
        },
      }),
    },

    Accordion: {
      styles: (theme) => ({
        control: {
          backgroundColor:
            theme.colorScheme === "dark" ? theme.colors.dark[6] : "white",
          borderRadius: 8,
          boxShadow:
            theme.colorScheme === "dark"
              ? "0 2px 5px rgba(0, 0, 0, 0.5)"
              : "0 2px 5px rgba(0, 0, 0, 0.1)",
        },
      }),
    },

    Checkbox: {
      styles: (theme) => ({
        input: {
          "&:disabled": {
            background: "white",
          },
        },
        label: {
          "&:disabled": {
            color: "red",
          },
        },
      }),
    },
  },
};
